import { create } from "zustand";
import {
  MenuItemData,
  UserMenuData,
} from "../../../../utilities/menus/MenuStruct";
import { DataNode } from "antd/es/tree";
import {
  initialUserRolePageState,
  RoleDetailType,
  UserRoleDataType,
  UserRoleListStateType,
} from "../core/_model";
import { ActionsKey } from "../../../../common/models/Actions";

export type ActionedRole = { data: any; action: ActionsKey };

type RoleData = {
  allRoles: UserMenuData | null;
  setAllRoles: (data: UserMenuData | null) => void;
  selected: Array<MenuItemData>;
  setSelected: (selected: Array<MenuItemData>) => void;
  treeData: DataNode[];
  setTreeData: (data: DataNode[]) => void;
  accessList: UserRoleDataType | null;
  totalItems?: number;
  setAccessList: (access: UserRoleDataType | null) => void;
  actioned: ActionedRole | null;
  setActioned: (act: ActionedRole | null) => void;
};

export const useRoleStore = create<RoleData>((set) => ({
  allRoles: null,
  setAllRoles: (data) => set((state) => ({ allRoles: data })),
  selected: [],
  setSelected: (selected) => set((state) => ({ selected: selected })),
  treeData: [],
  setTreeData: (data) => set((state) => ({ treeData: data })),
  accessList: null,
  setAccessList: (access) =>
    set(() => ({
      accessList: access,
      totalItems: access?.totalItems ?? 0,
    })),
  actioned: null,
  setActioned: (act) => set((state) => ({ actioned: act })),
}));

export const useUserRoleListState = create<UserRoleListStateType>((set) => ({
  pageState: initialUserRolePageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set({
      pageState: {
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      },
    }),
}));
